import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, Define, ValidationMessage, ValidationMessageType, CodeBlock,
} from '@appblocks/codegeneration/types';


export default class WM2000PWMLED extends BaseFeature {
    constructor() {
        super();
        this.name = 'WM2000EV PWM LED';
        this.id = 'wm2000ev_pwm_led';
        this.devices = ['WM2000EV'];
        this.requirements = ['WM2000EV'];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        const currentSocket = Number(this.getSettingValue('SOCKET'));
        const prevSocket = (currentSocket - 1).toString();
        const { project } = this;
        const NAME = 'EV_LED';

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'WM2000EV LED
    pwm.num =  PL_PWM_NUM_3
    pwm.enabled = NO
    pwm.dutycycle = 255
    pwm.frequency = 1000

    pwm.num =  PL_PWM_NUM_5
    pwm.enabled = NO
    pwm.dutycycle = 255
    pwm.frequency = 1000

    pwm.num =  PL_PWM_NUM_6
    pwm.enabled = NO
    pwm.dutycycle = 255
    pwm.frequency = 1000
`,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare sub WM2000EV_set_led(r as byte ,g as byte ,b as byte)
            `,
        });


        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.CODE,
            template: `
sub WM2000EV_set_led(r as byte ,g as byte ,b as byte)
    r=100-r
    g=100-g
    b=100-b
    pwm.num =  PL_PWM_NUM_3
    pwm.dutycycle = r
    pwm.enabled = YES

    pwm.num =  PL_PWM_NUM_5
    pwm.dutycycle = g
    pwm.enabled = YES

    pwm.num =  PL_PWM_NUM_6
    pwm.dutycycle = b
    pwm.enabled = YES
end sub
            `,
        });

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev';
    }
}
